import React, { Component, PropTypes } from 'react';

import css from './tooltip.scss';

export default class Tooltip extends Component {
	static propTypes = {
		attachTo: PropTypes.func.isRequired,
		height: PropTypes.number,
		width: PropTypes.number,
	};

	static defaultProps = {
		height: 0,
		width: 260,
	};

	constructor(props) {
		super();

		this.setActive = this.setActive.bind(this);
		this.setInactive = this.setInactive.bind(this);
		this.toggleActive = this.toggleActive.bind(this);

		this.state = {
			active: false,
			fading: false,
		}
	}

	componentDidMount() {
		let attachElement = this.props.attachTo();
		this.addListener(attachElement);
		this.addListener(this.refs.tooltip);
	}

	componentWillUnmount() {
		let attachElement = this.props.attachTo();
		this.removeListener(attachElement);
		this.removeListener(this.refs.tooltip);
	}

	componentWillUpdate(nextProps, nextState) {}

	componentWillReceiveProps(nProps) {}

	componentDidUpdate(prevProps, prevState) {}

	render() {
		let styles = {};
		let attachElement = this.props.attachTo();
		let tooltipOffsetTop = 0;
		let className = 'tooltip';

		if (attachElement) {
			tooltipOffsetTop = (attachElement.offsetTop + attachElement.offsetHeight);

			if (this.props.closer) {
				tooltipOffsetTop -= 10;
			}

			styles.top = tooltipOffsetTop + 'px';
			styles.left = attachElement.offsetLeft + 'px';
		}

		if (this.props.height) {
			styles.height = parseInt(this.props.height, 10) + 'px';
		}

		if (this.props.width) {
			let width = parseInt(this.props.width, 10);
			let maxWidth = this.getMaxWidth();
			styles.width = (width > maxWidth ? maxWidth : width)  + 'px';
		}

		if (this.state.active) {
			className += ' tooltip--active';
		}

		return (
			<div className={className} style={styles} ref='tooltip'>
				{this.props.children}
			</div>
		);
	}

	addListener(element) {
		if (element && typeof element.addEventListener === 'function') {
			element.addEventListener('mouseenter', this.setActive);
			element.addEventListener('mouseleave', this.setInactive);
			element.addEventListener('click', this.toggleActive);
		}
	}

	removeListener(element) {
		if (element && typeof element.removeEventListener === 'function') {
			element.removeEventListener('mouseenter', this.setActive);
			element.removeEventListener('mouseleave', this.setInactive);
			element.removeEventListener('click', this.toggleActive);
		}
	}

	setActive() {
		this.state.active = true;
		this.setState(this.state);
	}

	setInactive() {
		this.state.active = false;
		this.setState(this.state);
	}

	toggleActive() {
		this.state.active = !this.state.active;
		this.setState(this.state);
	}

	getMaxWidth() {
		if (document.documentElement && document.documentElement.clientHeight) {
			return document.documentElement.clientWidth - 40;
		}

		if (document.body) {
			return document.body.clientWidth - 40;
		}

		return 0;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/tooltip/tooltip.js
 **/